<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="start"><a id="chap1">Part One</a></h1><a id="chap1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5start.vue?0d7c2f48